import axios from "axios";
import { useEffect, useState } from "react";
import { AiOutlineSend } from "react-icons/ai";
import StatCard from "./stat_card";

const CardOne = ({ user }) => {
	const [stats, setStats] = useState({ totalCount: 0 });
	const [loading, setLoading] = useState(true);

	useEffect(() => {
		fetchUserStats();
	}, []);

	const fetchUserStats = async () => {
		try {
			const response = await axios.get(
				`${process.env.REACT_APP_API_URL}/api/v1/send-invitations/user-stats`,
				{
					headers: {
						Authorization: `Bearer ${user.token}`,
					},
				}
			);
			const data = await response.data.data;
			setStats(data);
		} catch (error) {
			console.error("Failed to fetch user statistics:", error);
		} finally {
			setLoading(false);
		}
	};

	return (
		<StatCard
			icon={<AiOutlineSend />}
			label="Total Invites"
			value={stats.totalCount}
			loading={loading}
			accentBg="bg-indigo-50"
			accentText="text-indigo-600"
			accentBar="from-indigo-500 to-indigo-400"
		/>
	);
};

export default CardOne;
